// File: packages/calculator/components/BundleSelector.tsx

import React from 'react';
import { Button } from '@dopomogai/ui';
import { Star } from 'lucide-react';
import { useCalculator } from '@dopomogai/agent-kit';

/**
 * A component that displays a selection of presets (bundles)
 * for users to quickly configure the calculator.
 */
export function BundleSelector() {
  const { spec, state, actions } = useCalculator();

  if (!spec.presets || spec.presets.length === 0) {
    return null;
  }

  return (
    <section>
      <div className="mb-3 font-extrabold text-slate-900">2. Start with a preset (optional)</div>
      <div className="flex flex-wrap gap-2">
        {spec.presets.map((preset) => {
          const isActive = state.presetId === preset.id;
          return (
            <Button
              key={preset.id}
              variant={isActive ? 'primary' : 'outline'}
              onClick={() => actions.setPreset(isActive ? undefined : preset.id)}
              aria-pressed={isActive}
              title={preset.desc || preset.label}
              icon={preset.recommended ? <Star className="w-4 h-4 text-amber-400" /> : undefined}
            >
              {preset.label}
            </Button>
          );
        })}
      </div>
      {state.presetId && (
        <p className="text-xs text-slate-600 mt-2">
          A preset has pre-selected some features for you. You can still add or remove items individually below.
        </p>
      )}
    </section>
  );
}